import DenhaagHeroCarousel from "./components/DenhaagHeroCarousel";
const heroCarousel = new DenhaagHeroCarousel();

window.addEventListener( "DOMContentLoaded", () => heroCarousel.initSlider() );
window.addEventListener( "dh:resize", () => heroCarousel.resize() );
